import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Vente from "@/pages/Vente";
import LocationLongue from "@/pages/LocationLongue";
import LocationSaisonniere from "@/pages/LocationSaisonniere";
import Conseil from "@/pages/Conseil";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import BecomeAgency from "@/pages/BecomeAgency";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Handle Emergent OAuth callback: session_id arrives in URL fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isDashboard = location.pathname.startsWith("/dashboard");
  return (
    <>
      {!isDashboard && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vente" element={<Vente />} />
        <Route path="/location-longue" element={<LocationLongue />} />
        <Route path="/location-saisonniere" element={<LocationSaisonniere />} />
        <Route path="/conseil" element={<Conseil />} />
        <Route path="/property/:id" element={<PropertyDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/devenir-agence" element={<BecomeAgency />} />
      </Routes>
      {!isDashboard && <Footer />}
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <CurrencyProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" />
          </BrowserRouter>
        </AuthProvider>
      </CurrencyProvider>
    </I18nProvider>
  );
}

export default App;
